import type React from 'react';
import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsBaseball = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox="0 0 20 20">
        <path
            d="M3.479 15.1875C2.89567 14.4375 2.44775 13.6215 2.13525 12.7396C1.82275 11.8577 1.6665 10.9445 1.6665 10C1.6665 9.05558 1.82275 8.14238 2.13525 7.26044C2.44775 6.37849 2.89567 5.56252 3.479 4.81252C4.28456 5.43752 4.9165 6.20488 5.37484 7.1146C5.83317 8.02433 6.06234 8.98613 6.06234 10C6.06234 11.0139 5.83317 11.9757 5.37484 12.8854C4.9165 13.7952 4.28456 14.5625 3.479 15.1875ZM9.99984 18.3334C8.99984 18.3334 8.04498 18.1667 7.13525 17.8334C6.22553 17.5 5.39567 17.0139 4.64567 16.375C5.604 15.5834 6.354 14.6354 6.89567 13.5313C7.43734 12.4271 7.70817 11.25 7.70817 10C7.70817 8.75002 7.43734 7.57294 6.89567 6.46877C6.354 5.3646 5.604 4.41669 4.64567 3.62502C5.39567 2.98613 6.22553 2.50002 7.13525 2.16669C8.04498 1.83335 8.99984 1.66669 9.99984 1.66669C10.9998 1.66669 11.9547 1.83335 12.8644 2.16669C13.7741 2.50002 14.604 2.98613 15.354 3.62502C14.3957 4.41669 13.6457 5.3646 13.104 6.46877C12.5623 7.57294 12.2915 8.75002 12.2915 10C12.2915 11.25 12.5623 12.4271 13.104 13.5313C13.6457 14.6354 14.3957 15.5834 15.354 16.375C14.604 17.0139 13.7741 17.5 12.8644 17.8334C11.9547 18.1667 10.9998 18.3334 9.99984 18.3334ZM16.5207 15.1875C15.7151 14.5625 15.0832 13.7952 14.6248 12.8854C14.1665 11.9757 13.9373 11.0139 13.9373 10C13.9373 8.98613 14.1665 8.02433 14.6248 7.1146C15.0832 6.20488 15.7151 5.43752 16.5207 4.81252C17.104 5.56252 17.5519 6.37849 17.8644 7.26044C18.1769 8.14238 18.3332 9.05558 18.3332 10C18.3332 10.9445 18.1769 11.8577 17.8644 12.7396C17.5519 13.6215 17.104 14.4375 16.5207 15.1875Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
